import React from 'react'
import { Card, CardHeader, Button, CardTitle, CardSubtitle } from 'reactstrap'
import { Form, InputGroup } from 'react-bootstrap'

export default function ListTopBar({ 
	filterType, 
	setFilterType, 
	filterValue, 
	setFilterValue, 
	reload,
	title,
	subtitle,
	options,
	ctaText,
	handleCtaClick,
	className,
	prefix,
	onExport,
	secundaryCtaText,
	handleSecundaryCtaClick
}) {
	return (
		<React.Fragment>
			<Card className={className}>
				<CardHeader>
					{ options && (
						<div className="float-right mt-2 mb-2">
							<InputGroup>
								{ prefix && (
									<InputGroup.Prepend>
										{prefix}
									</InputGroup.Prepend>
								)}
								<InputGroup.Prepend>
									<Form.Control 
										as="select" 
										className="bg-light"
										value={filterType}
										onChange={e => setFilterType(e.target.value)}
									>
										{options.map((option,i) => 
											<option key={i} value={option.value}>{option.label}</option>
										)}
									</Form.Control>
								</InputGroup.Prepend>
								<Form.Control 
									placeholder="Escriba aquí" 
									value={filterValue}
									onChange={e => setFilterValue(e.target.value)}
								/>
								<InputGroup.Append className="mb-1">
									<Button color={ctaText ? 'dark' : 'primary'} onClick={reload}>Buscar</Button>
								</InputGroup.Append>
								{ secundaryCtaText && (
									<Button className="ml-2 mb-1" color="primary" onClick={handleSecundaryCtaClick}>{secundaryCtaText}</Button>
								)}
								{ ctaText && (
									<Button className="ml-2 mb-1" color="primary" onClick={handleCtaClick}>{ctaText}</Button>
								)}
								{ onExport && (
									<Button className="ml-2 mb-1" color="primary" onClick={onExport}>Exportar</Button>
								)}
							</InputGroup>
						</div>
					)}
					{ title && <CardTitle>{title}</CardTitle> }
					{ subtitle && <CardSubtitle>{subtitle}</CardSubtitle> }
				</CardHeader>
			</Card>
		</React.Fragment>
	)
}